var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoresBottomMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5833 0H0V15.5833H15.5833V0ZM8.5 2.83333H4.25V4.25H7.08333V11.3333H4.25V12.75H11.3333V11.3333H8.5V2.83333Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 0H18.4166V15.5833H34V0ZM31.1667 2.83333H21.25V4.25H31.1667V7.08333L22.6667 7.08333V8.5H21.25V12.75H32.5833V11.3333H22.6667V8.5H31.1667V7.08333H32.5833V4.25H31.1667V2.83333Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5833 18.4167H0V34H15.5833V18.4167ZM11.3334 21.25H2.83337V22.6667H11.3333V25.5H5.66667V26.9167H11.3333V29.75H2.83333V31.1667H11.3333V29.75H12.75V26.9167H11.3333V25.5H12.75V22.6667H11.3333L11.3334 21.25Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 18.4167H18.4166V34H34V18.4167ZM22.6667 21.25H21.25V25.5H22.6667V26.9167H29.75V32.5834H31.1667V21.25H29.75V25.5H22.6667V21.25Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoresBottomMenu);
export default __webpack_public_path__ + "static/media/ScoresBottomMenu.0881354d47c765d5314671e41f9551ec.svg";
export { ForwardRef as ReactComponent };